/*
 * Filename: template-selection-panel.component.tsx
 * Description: Landing page for template configuration.
 */

import React, { Component, ReactNode, BaseSyntheticEvent } from 'react';
import { observer } from 'mobx-react';
import TemplateConfigurationController from './template-config.controller';
import { ErrorMessage } from 'formik';
import { CQMasterDataStore } from '../../store/cq-master-data.store';
import { TemplateSFObjectStore } from '../../store/models/template-object.model';
import { CQAppConstant } from '../../app-constants';
import { CQAppStore } from './../../store/cq-app-store';
import Cookies from 'universal-cookie';

class CQTemplateSelectionPanelClass extends Component<{ setSelectedObject:Function, handleChange: Function, templateName: string, isLayoutApplicable: boolean, errors: any, touched: any, shouldSelectionPanelResetAndDisable: boolean }, {
    selectedObjectName: string,
    selectedLayoutName: any, isObjectSelectionDisabled: boolean
    recordType:any
}> {
    private readonly templateConfigCtrl: TemplateConfigurationController;
    private readonly cookie: Cookies;
    constructor(props: Readonly<{ setSelectedObject:Function, handleChange: Function, templateName: string, isLayoutApplicable: boolean, errors: any, touched: any, shouldSelectionPanelResetAndDisable: boolean }>) {
        super(props);
        this.templateConfigCtrl = new TemplateConfigurationController();
        this.cookie = new Cookies();
        this.state = {
            selectedObjectName: '',
            selectedLayoutName: '',
            isObjectSelectionDisabled: false,
            recordType:''
        };
    }

    async componentDidMount() {
        if (this.props.isLayoutApplicable|| this.props.templateName === CQAppConstant.CQNBA) {
            await this.templateConfigCtrl.getObjects();
            // this.templateConfigCtrl.getLayout(this.props.templateName,'CQ Complaint Create', 'compliancequest__SQX_Complaint__c ', '01I6g0000023M0CEAU');
        }
        const deployedTemplate = CQMasterDataStore.OutputConfig;
        const { selectedObject, selectedLayout, selectedLayoutName } = deployedTemplate.getStoreData(this.props.templateName);
        const deployedObjectName = selectedObject;
        let deployedLayoutId = selectedLayout
        const deployedLayoutName = selectedLayoutName;
        if (deployedObjectName) {
            const orgNameSpace = this.templateConfigCtrl.getCookieValue(CQAppConstant.LOGGED_IN_ORG_NAME_SPACE);
            this.templateConfigCtrl.getBaseClassNames(deployedObjectName,orgNameSpace);
            if(deployedLayoutId){
                await this.templateConfigCtrl.getLayouts(deployedObjectName);
                let layoutObj: any[] = TemplateSFObjectStore.templateLayouts.filter((templateLayout: any) => {
                    return templateLayout.Id === deployedLayoutId;
                });
                if (!layoutObj[0]){
                    for(let i in TemplateSFObjectStore.templateLayouts ){
                        if(deployedLayoutName === TemplateSFObjectStore.templateLayouts[i].Name){
                            deployedLayoutId = TemplateSFObjectStore.templateLayouts[i].Id;
                            layoutObj =[TemplateSFObjectStore.templateLayouts[i]];
                            break;
                        }
                    }
                }
                this.templateConfigCtrl.setLayout(this.props.templateName, deployedLayoutId);
                await this.templateConfigCtrl.getLayout(this.props.templateName, layoutObj[0].Name, deployedObjectName, layoutObj[0].TableEnumOrId);
                this.templateConfigCtrl.clearFieldRulesConfigurations(this.props.templateName);
            } 
            this.setState({
                selectedObjectName: deployedObjectName,
                isObjectSelectionDisabled: true,
                selectedLayoutName: deployedLayoutId
            });
        }
        if(this.props.templateName.includes('100')){
            let orgNameSpace = this.templateConfigCtrl.getCookieValue(CQAppConstant.LOGGED_IN_ORG_NAME_SPACE);
            orgNameSpace = !orgNameSpace ? CQAppConstant.DEFAULT_COMPONENT_NAME_SPACE : orgNameSpace;
            this.templateConfigCtrl.updateInputField(this.props.templateName, 'componentNamespace', orgNameSpace);
        }
    }

    componentDidUpdate(prevProps: any){
        if(prevProps.shouldSelectionPanelResetAndDisable !== this.props.shouldSelectionPanelResetAndDisable && this.props.shouldSelectionPanelResetAndDisable){
            this.setState({ selectedObjectName: '', selectedLayoutName: '' });
        }
    }

    onObjectChanged = (e: BaseSyntheticEvent) => {
        const orgNameSpace = this.templateConfigCtrl.getCookieValue(CQAppConstant.LOGGED_IN_ORG_NAME_SPACE);
        const selectedLayout = this.templateConfigCtrl.getSelectedLayout(this.props.templateName);
        const { selectedObject, prefixName } = CQMasterDataStore.OutputConfig.getStoreData(this.props.templateName);
        
        //sets the value of prefix when component is load from org
        if (selectedObject) {
            this.templateConfigCtrl.setPrefixName(this.props.templateName, false, prefixName);
        }
        if (e.target.value !== '') {
            if (!selectedLayout) {
                if(this.props.templateName!==CQAppConstant.CQNBA){
                    this.templateConfigCtrl.setLayout(this.props.templateName, '');
                    this.templateConfigCtrl.resetLayoutList();
                    this.templateConfigCtrl.getLayouts(e.target.value);
                    this.templateConfigCtrl.getBaseClassNames(e.target.value,orgNameSpace);
                }
                this.setState({ selectedObjectName: e.target.value, selectedLayoutName: '' });
                this.templateConfigCtrl.setSelectedObject(this.props.templateName, e.target.value);
                this.templateConfigCtrl.updateInputField(this.props.templateName, 'className', '');
                this.props.setSelectedObject(e.target.value);
            } else {
                if (window.confirm(CQAppConstant.CONFIRM_MESSAGE_LAYOUT_CHANGE)) {
                    this.templateConfigCtrl.getBaseClassNames(e.target.value,orgNameSpace);
                    this.templateConfigCtrl.setLayout(this.props.templateName, '');
                    this.setState({ selectedObjectName: e.target.value, selectedLayoutName: '' });
                    this.templateConfigCtrl.resetLayoutList();
                    CQMasterDataStore.OutputConfig.reset();
                    CQMasterDataStore.RuleElements.reset();
                    this.templateConfigCtrl.getLayouts(e.target.value);
                    this.templateConfigCtrl.setSelectedObject(this.props.templateName, e.target.value);
                    this.templateConfigCtrl.updateInputField(this.props.templateName, 'className', '');
                    this.props.setSelectedObject(e.target.value);
                }
            }
            this.templateConfigCtrl.setPrefixName(this.props.templateName, true);     
            const componentName = this.templateConfigCtrl.generateComponentName(this.props.templateName);
            this.templateConfigCtrl.updateInputField(this.props.templateName, 'componentName', componentName);
            if(this.props.templateName=='cqNBA'){
                if(this.state.selectedObjectName!==''){
                    window.confirm(CQAppConstant.CONFIRM_MESSAGE_OBJECT_CHANGE);
                    TemplateSFObjectStore.resetQuickActions();
                    CQMasterDataStore.OutputConfig.reset();
                    CQMasterDataStore.RuleElements.reset();
                }
                this.templateConfigCtrl.getLayout(this.props.templateName,'', e.target.value,'');
            }
        }
    }

    /**
     * @description Opens the SF layout editor page in new tab
     * @memberof CQTemplateSelectionPanel 
     */
    loadSFLayoutEditWindow = (recType:any) => {
        const baseURL = this.cookie.get(CQAppConstant.INSTANCE_URL);
        const tableEnumOrId:string = TemplateSFObjectStore.templateLayouts[0].TableEnumOrId;
        const customObjectId:string = tableEnumOrId.slice(0,-3);
        let win:any;
        if(recType === 'Layout'){
            let sfLayoutEditURL:string = CQAppConstant.SF_LAYOUT_EDIT_URL;
            sfLayoutEditURL = sfLayoutEditURL.replace('{{baseURL}}',baseURL)
                                             .replace('{{objectId}}',customObjectId)
                                             .replace('{{layoutId}}',this.state.selectedLayoutName);
            win = window.open(sfLayoutEditURL, "Layout Editor");
        }else if(recType === 'FlexiPage'){
            let sfFlexiPageEditURL:string = CQAppConstant.SF_FLEXIPAGE_EDIT_URL;
            sfFlexiPageEditURL = sfFlexiPageEditURL.replace('{{baseURL}}',baseURL)
                                             .replace('{{layoutId}}',this.state.selectedLayoutName);
            win = window.open(sfFlexiPageEditURL, "Flexipage Editor");
        }

        let timer = setInterval(() => {
            if (!win?.closed) {
                CQAppStore.loader.setVisibility(true, CQAppConstant.INFO_MESSAGE_SF_LAYOUT_EDITOR, false, true);
            }else{
                clearInterval(timer);
                this.templateConfigCtrl.refreshLayout(this.props.templateName);
            }
        }, 300);   
    }

    onLayoutChanged = async (e: BaseSyntheticEvent) => {
        const selectedLayout = this.templateConfigCtrl.getSelectedLayout(this.props.templateName);
        const { options, selectedIndex } = e.target;
        if (e.target.value !== '') {
            if (selectedLayout === '') {
                this.setState({ selectedLayoutName: e.target.value });
                this.getLayoutMetadataOnLayoutChanged(e.target.value, options, selectedIndex);
            } else {
                if (window.confirm(CQAppConstant.CONFIRM_MESSAGE_LAYOUT_CHANGE)) {
                    this.setState({ selectedLayoutName: e.target.value });
                    CQMasterDataStore.OutputConfig.reset();
                    CQMasterDataStore.RuleElements.reset();
                    this.templateConfigCtrl.setSelectedObject(this.props.templateName, this.state.selectedObjectName);
                    this.getLayoutMetadataOnLayoutChanged(e.target.value, options, selectedIndex);
                }
            }
        }
    }

    public getLayoutMetadataOnLayoutChanged = async (layoutId: string, options: any, selectedIndex: number) => {
        if (layoutId !== '') {
            const layoutObj: any = TemplateSFObjectStore.templateLayouts.filter((templateLayout: any) => {
                return templateLayout.Id === layoutId;
            });
            this.templateConfigCtrl.setLayout(this.props.templateName, layoutId);
            this.setState({recordType: layoutObj[0].attributes.type});
            this.templateConfigCtrl.updateInputField(this.props.templateName, 'selectedLayoutName', options[selectedIndex].innerHTML);
            await this.templateConfigCtrl.getLayout(this.props.templateName, options[selectedIndex].innerHTML, this.state.selectedObjectName, layoutObj[0].TableEnumOrId);
            // this.templateConfigCtrl.clearFieldRulesConfigurations(this.props.templateName);
        }
    }

    public render(): ReactNode {
        const { shouldSelectionPanelResetAndDisable } = this.props;
        return (
            <>
                <div className="slds-col config-sidebar full-height" data-testid="selection-panel">
                    <div className="bg-white full-height scroll-content slds-p-around_small">
                        {/* <h2 className="slds-text-heading_small slds-m-bottom_small">Template Name</h2> */}
                        <div className="slds-grid slds-grid_vertical">
                            {(this.props.isLayoutApplicable || this.props.templateName=== CQAppConstant.CQNBA) &&
                                <>
                                    <div className="slds-form-element">
                                    <label className="slds-form-element__label slds-text-body_medium" htmlFor="select-01">{this.props.templateName === "cqEsig100" ? 'Form' : 'Select'} Object</label>
                                        <div className="slds-form-element__control">
                                            <div className="slds-select_container">
                                                {/* <Field as="select" name="selectObject" className="slds-select" id="select-01" onChange={() => this.props.handleChange('select')}> */}
                                                <select 
                                                    name="selectedObject" 
                                                    className="slds-select" 
                                                    id="select-01" 
                                                    onChange={this.onObjectChanged} 
                                                    data-testid="object-select"
                                                    disabled={shouldSelectionPanelResetAndDisable || this.state.isObjectSelectionDisabled} 
                                                    value={this.state.selectedObjectName}
                                                >
                                                    <option value="">Please select</option>
                                                    {TemplateSFObjectStore.sfObjects.map((sfObject) => {
                                                        return (<option key={sfObject.name} value={sfObject.name}>{sfObject.label}</option>);
                                                    })};
                                                 </select>
                                                {/* </Field> */}
                                            </div>
                                        </div>
                                        <ErrorMessage component="span" className="slds-text-color_destructive" name="selectObject" />
                                    </div>
                                    {this.props.templateName!== CQAppConstant.CQNBA &&
                                    <div>
                                        <div className="slds-form-element">
                                            <label className="slds-form-element__label slds-text-body_medium" htmlFor="select-02">{this.props.templateName === "cqEsig100" ? 'Form' : 'Select'} Layout/Record Page</label>
                                            <div className="slds-form-element__control">
                                                <div className="slds-select_container">
                                                    {/* <Field as="select" name={"selectLayout"} className="slds-select" id="select-02" onChange={this.onLayoutChanged}> */}
                                                    <select
                                                        data-testid="layout-select"
                                                        name={'selectedLayout'}
                                                        className="slds-select"
                                                        id="select-02"
                                                        onChange={(e) => this.onLayoutChanged(e)}
                                                        value={this.state.selectedLayoutName}
                                                        disabled={shouldSelectionPanelResetAndDisable}
                                                    >
                                                        <option value="">Please select</option>
                                                        {TemplateSFObjectStore.templateLayouts.map((layout) => {
                                                            return (<option key={layout.Id} value={layout.Id}>{layout.Name}</option>);
                                                        })};
                                                        </select>
                                                    {this.props.errors.selectLayout &&
                                                        this.props.touched.selectLayout &&
                                                        <div className="input-feedback">
                                                            {this.props.errors.selectLayout}
                                                        </div>}
                                                </div>
                                            </div>
                                        </div>
                                        <div className="slds-form-element">
                                            <button className="slds-button slds-button_neutral full-width slds-m-bottom_small"
                                                disabled={this.state.recordType === '' ? true : false}
                                                onClick={() => this.loadSFLayoutEditWindow(this.state.recordType)}>
                                                Open SF {this.state.recordType === 'FlexiPage'? 'Record Page' : 'Layout'} Editor
                                            </button>
                                        </div>
                                    </div>}
                                </>
                            }
                        </div>
                    </div>
                </div>
            </>
        );
    }
}

export const CQTemplateSelectionPanel = observer(CQTemplateSelectionPanelClass);
